import { Formik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
    attPreSinAnt,
    attPregestacionalOpt,
    noAplicaOpt,
    noSiOpt,
    opt123,
    primeraVezSubsecuentaOpt,
} from "./constants/options";
import Controller from "./controller/Controller";
import { Fragment, useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import Post from "../../../api/Post";
import { MEDICAL_HISTORY_MX } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import Put from "../../../api/Put";
import SimpleLoad from "../../../loader/SimpleLoad";
import Get from "../../../api/Get";

const fields1 = [
    {
        name: "enfermedadRespiratoria",
        type: "select",
        label: "Enfermedades Respiratorias",
        options: [
            ...noAplicaOpt,
            { label: 'Covid', value: 'Covid' },
            { label: 'Tuberculosis', value: 'Tuberculosis' },
            { label: 'Influenza', value: 'Influenza' },
            { label: 'Otras', value: 'Otras' }
        ],
    },
    {
        name: "enfermedadRepeticion",
        type: "select",
        label: "Enfermedades de Repetición",
        options: [
            { label: 'Sí', value: 'Sí' },
            { label: 'No', value: 'No' }
        ],
    },
    {
        name: "fechaDeteccionRepeticion",
        type: "text",
        label: "Fecha de detección",
        options: [],
    },
    {
        name: "tratamientoRepeticion",
        type: "text",
        label: "Tratamiento",
        options: [],
    },
    {
        name: "observacionesRepeticion",
        type: "text",
        label: "Observaciones",
        options: [],
    },
];

const fields2 = [
    {
        name: "enfermedadCancer",
        type: "select",
        label: "Cáncer",
        options: [
            { label: 'Sí', value: 'Sí' },
            { label: 'No', value: 'No' }
        ],
    },
    {
        name: "fechaDeteccionCancer",
        type: "text",
        label: "Fecha de detección",
        options: [],
    },
    {
        name: "tratamientoCancer",
        type: "text",
        label: "Tratamiento",
        options: [],
    },
    {
        name: "observacionesCancer",
        type: "text",
        label: "Observaciones",
        options: [],
    },
];

export default function AntPersPatologicos({
    setShowModalServer,
    setErrorServer,
    setShowSuccess,
    citaId,
    pato = null,
}) {
    const { auth } = useContext(authContext);
    const [isSubmiting, setSubmiting] = useState(false);
    const schema = Yup.object().shape({
        enfermedadRespiratoria: Yup.string().required('Requerido'),
        enfermedadRepeticion: Yup.string().required('Requerido'),
        fechaDeteccionRepeticion: Yup.date()
            .nullable()
            .typeError('Ingrese una fecha válida (dd/mm/aaaa)')
            .when('enfermedadRepeticion', {
                is: 'Sí',
                then: Yup.date().required('Requerido').typeError('Ingrese una fecha válida (dd/mm/aaaa)'),
            }),
        tratamientoRepeticion: Yup.string().when('enfermedadRepeticion', {
            is: 'Sí',
            then: Yup.string().required('Requerido'),
        }),
        observacionesRepeticion: Yup.string().when('enfermedadRepeticion', {
            is: 'Sí',
            then: Yup.string().required('Requerido'),
        }),
        enfermedadCancer: Yup.string().required('Requerido'),
        fechaDeteccionCancer: Yup.date().when('enfermedadCancer', {
            is: 'Sí',
            then: Yup.date().required('Requerido'),
        }),
        tratamientoCancer: Yup.string().when('enfermedadCancer', {
            is: 'Sí',
            then: Yup.string().required('Requerido'),
        }),
        observacionesCancer: Yup.string().when('enfermedadCancer', {
            is: 'Sí',
            then: Yup.string().required('Requerido'),
        }),
    });
    const [initValues, setInitValues] = useState(pato);

    useEffect(() => {
        if (initValues?.id) {
            setSubmiting(true);
            Get({
                url: `${MEDICAL_HISTORY_MX}/find-pathological/${initValues.id}`,
                access_token: auth.data.access_token,
            })
                .then((response) => {
                    setInitValues(response.data);
                    setSubmiting(false);
                })
                .catch((error) => {
                    console.log(error);
                    setSubmiting(false);
                });
        }
    }, [initValues?.id, auth.data.access_token]);

    return (
        <>
            <Formik
                initialValues={
                    initValues
                        ? initValues
                        : {
                            appointmentId: citaId,
                            enfermedadRespiratoria: '',
                            enfermedadRepeticion: '',
                            fechaDeteccionRepeticion: '',
                            tratamientoRepeticion: '',
                            observacionesRepeticion: '',
                            enfermedadCancer: '',
                            fechaDeteccionCancer: '',
                            tratamientoCancer: '',
                            observacionesCancer: '',
                        }
                }
                validationSchema={schema}
                enableReinitialize
                onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                    setSubmiting(true);
                    if (values.id) {
                        const body = {
                            id: values.id,
                            ...values,
                        };
                        try {
                            const response = await Put({
                                url: `${MEDICAL_HISTORY_MX}/update-pathological/`,
                                data: body,
                                access_token: auth.data.access_token,
                                header: true,
                            });
                            setInitValues(response.data);
                            setSubmiting(false);
                            setTimeout(() => {
                                setShowSuccess(false);
                            }, 2000);
                        } catch (error) { }
                    } else {
                        try {
                            const response = await Post({
                                url: `${MEDICAL_HISTORY_MX}/save-pathological/`,
                                data: values,
                                access_token: auth.data.access_token,
                                header: true,
                            });
                            setInitValues(response.data);
                            setSubmiting(false);
                            setTimeout(() => {
                                setShowSuccess(false);
                            }, 2000);
                        } catch (error) {
                            setSubmiting(false);
                            setShowModalServer(true);
                            if (error.response) {
                                setErrorServer(error.response);
                            }
                        }
                    }
                }}
            >
                {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
                    <Form onSubmit={handleSubmit}>
                        {isSubmiting && <SimpleLoad />}
                        <Row>
                            <Col xs="12" md="6">
                                <dl className="row">
                                    {fields1.map((it) => (
                                        <Fragment key={it.name}>
                                            {(it.name !== 'fechaDeteccionRepeticion' && it.name !== 'tratamientoRepeticion' && it.name !== 'observacionesRepeticion' && it.name !== 'fechaDeteccionCancer' && it.name !== 'tratamientoCancer' && it.name !== 'observacionesCancer') ||
                                                (it.name === 'fechaDeteccionRepeticion' && values.enfermedadRepeticion === 'Sí') ||
                                                (it.name === 'tratamientoRepeticion' && values.enfermedadRepeticion === 'Sí') ||
                                                (it.name === 'observacionesRepeticion' && values.enfermedadRepeticion === 'Sí') ||
                                                (it.name === 'fechaDeteccionCancer' && values.enfermedadCancer === 'Sí') ||
                                                (it.name === 'tratamientoCancer' && values.enfermedadCancer === 'Sí') ||
                                                (it.name === 'observacionesCancer' && values.enfermedadCancer === 'Sí') ? (
                                                <Fragment>
                                                    <dt className="col-sm-5">{it.label}</dt>
                                                    <dd className="col-sm-7">
                                                        <Controller
                                                            type={it.type}
                                                            name={it.name}
                                                            errors={errors}
                                                            onChange={handleChange}
                                                            options={it.options}
                                                        />
                                                    </dd>
                                                </Fragment>
                                            ) : null}
                                        </Fragment>
                                    ))}
                                </dl>
                            </Col>
                            <Col xs="12" md="6">
                                <dl className="row">
                                    {fields2.map((it) => (
                                        <Fragment key={it.name}>
                                            {(it.name !== 'fechaDeteccionRepeticion' && it.name !== 'tratamientoRepeticion' && it.name !== 'observacionesRepeticion' && it.name !== 'fechaDeteccionCancer' && it.name !== 'tratamientoCancer' && it.name !== 'observacionesCancer') ||
                                                (it.name === 'fechaDeteccionRepeticion' && values.enfermedadRepeticion === 'Sí') ||
                                                (it.name === 'tratamientoRepeticion' && values.enfermedadRepeticion === 'Sí') ||
                                                (it.name === 'observacionesRepeticion' && values.enfermedadRepeticion === 'Sí') ||
                                                (it.name === 'fechaDeteccionCancer' && values.enfermedadCancer === 'Sí') ||
                                                (it.name === 'tratamientoCancer' && values.enfermedadCancer === 'Sí') ||
                                                (it.name === 'observacionesCancer' && values.enfermedadCancer === 'Sí') ? (
                                                <Fragment>
                                                    <dt className="col-sm-5">{it.label}</dt>
                                                    <dd className="col-sm-7">
                                                        <Controller
                                                            type={it.type}
                                                            name={it.name}
                                                            errors={errors}
                                                            onChange={handleChange}
                                                            options={it.options}
                                                        />
                                                    </dd>
                                                </Fragment>
                                            ) : null}
                                        </Fragment>
                                    ))}
                                </dl>
                            </Col>
                        </Row>
                        <hr />
                        <Row>
                            <Col className="text-right">
                                <Button
                                    variant="outline-success"
                                    className="ok-buttom"
                                    type="submit"
                                >
                                    Guardar
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </>
    );
}